(function () {
  function initCarousel(container) {
    if (container.dataset.gfeCarousel) return;

    var items = Array.from(container.querySelectorAll('.product-recommendation-list-row-item'));
    if (items.length <= 1) return;

    container.dataset.gfeCarousel = '1';

    var current = 0;

    items.forEach(function (item, i) {
      item.style.display = i === 0 ? '' : 'none';
    });

    var headings = container.querySelector('.block-headings');
    var nav = document.createElement('div');
    nav.className = 'gfe-comp-nav';
    nav.innerHTML =
      '<button class="gfe-comp-btn gfe-comp-prev" aria-label="Previous">&#8249;</button>' +
      '<button class="gfe-comp-btn gfe-comp-next" aria-label="Next">&#8250;</button>';

    if (headings) {
      headings.appendChild(nav);
    } else {
      var list = container.querySelector('.product-recommendation-list-row');
      if (list) list.parentNode.insertBefore(nav, list);
    }

    var prevBtn = nav.querySelector('.gfe-comp-prev');
    var nextBtn = nav.querySelector('.gfe-comp-next');

    function update() {
      items.forEach(function (item, i) {
        item.style.display = i === current ? '' : 'none';
      });
      prevBtn.disabled = current === 0;
      nextBtn.disabled = current === items.length - 1;
    }

    prevBtn.addEventListener('click', function () {
      if (current > 0) { current--; update(); }
    });

    nextBtn.addEventListener('click', function () {
      if (current < items.length - 1) { current++; update(); }
    });

    update();
  }

  var observer = null;

  function tryInit() {
    var container = document.querySelector('.product-info .product-recommendations');
    if (!container) return;
    var items = container.querySelectorAll('.product-recommendation-list-row-item');
    if (items.length === 0) return;
    initCarousel(container);
    // Recommendations are loaded once via AJAX; stop observing after we've wired up.
    if (container.dataset.gfeCarousel && observer) {
      observer.disconnect();
      observer = null;
    }
  }

  function boot() {
    tryInit();
    // Only keep watching if the carousel hasn't initialized yet (items arrive via AJAX).
    var container = document.querySelector('.product-info .product-recommendations');
    if (container && container.dataset.gfeCarousel) return;
    observer = new MutationObserver(tryInit);
    observer.observe(document.body, { childList: true, subtree: true });
    // Safety net: stop observing after 15s even if recommendations never load.
    setTimeout(function () {
      if (observer) { observer.disconnect(); observer = null; }
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
